// extracted by mini-css-extract-plugin
export default {"createClass":"a_createClass__NBUjB","createButtonDiv":"a_createButtonDiv__EDwO4","singleButtonDiv":"a_singleButtonDiv__2OqSM","classDefinition":"a_classDefinition__2WcS4"};